/* Action-type constants for Events-Calendar-Details Redux flow */
export const ACTIONS = {
  /* ---------- LIST ---------- */
  EVENTS_CALENDAR_DETAILS_FETCH_START: 'EVENTS_CALENDAR_DETAILS_FETCH_START',
  EVENTS_CALENDAR_DETAILS_FETCH_SUCCESS: 'EVENTS_CALENDAR_DETAILS_FETCH_SUCCESS',
  EVENTS_CALENDAR_DETAILS_FETCH_FAILURE: 'EVENTS_CALENDAR_DETAILS_FETCH_FAILURE',

  /* ---------- SINGLE ---------- */
  EVENTS_CALENDAR_DETAIL_FETCH_START: 'EVENTS_CALENDAR_DETAIL_FETCH_START',
  EVENTS_CALENDAR_DETAIL_FETCH_SUCCESS: 'EVENTS_CALENDAR_DETAIL_FETCH_SUCCESS',
  EVENTS_CALENDAR_DETAIL_FETCH_FAILURE: 'EVENTS_CALENDAR_DETAIL_FETCH_FAILURE',

  /* ---------- CREATE / UPDATE / DELETE ---------- */
  EVENTS_CALENDAR_DETAIL_CREATE_START: 'EVENTS_CALENDAR_DETAIL_CREATE_START',
  EVENTS_CALENDAR_DETAIL_CREATE_SUCCESS: 'EVENTS_CALENDAR_DETAIL_CREATE_SUCCESS',
  EVENTS_CALENDAR_DETAIL_CREATE_FAILURE: 'EVENTS_CALENDAR_DETAIL_CREATE_FAILURE',

  EVENTS_CALENDAR_DETAIL_UPDATE_START: 'EVENTS_CALENDAR_DETAIL_UPDATE_START',
  EVENTS_CALENDAR_DETAIL_UPDATE_SUCCESS: 'EVENTS_CALENDAR_DETAIL_UPDATE_SUCCESS',
  EVENTS_CALENDAR_DETAIL_UPDATE_FAILURE: 'EVENTS_CALENDAR_DETAIL_UPDATE_FAILURE',

  EVENTS_CALENDAR_DETAIL_DELETE_START: 'EVENTS_CALENDAR_DETAIL_DELETE_START',
  EVENTS_CALENDAR_DETAIL_DELETE_SUCCESS: 'EVENTS_CALENDAR_DETAIL_DELETE_SUCCESS',
  EVENTS_CALENDAR_DETAIL_DELETE_FAILURE: 'EVENTS_CALENDAR_DETAIL_DELETE_FAILURE',

  /* ---------- RESET helper ---------- */
  EVENTS_CALENDAR_DETAIL_RESET: 'EVENTS_CALENDAR_DETAIL_RESET',
};
